import { Box, Flex, useBreakpointValue, Text, Image, Breadcrumb, BreadcrumbItem } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link as ReactLink } from 'react-router-dom';
import Palyazatok from '../components/Palyazatok';

const PalyazatScreen = () => {
  const blobSvgHeight = useBreakpointValue({ base: "200px", md: "400px" });
  const bgPosition = useBreakpointValue({ base: "30% 30%", md: "30% 65%" });
  const labelFontSize = useBreakpointValue({ base: "sm", md: "md" });
  const valueFontSize = useBreakpointValue({ base: "sm", md: "md" });
  const headingFontSize = useBreakpointValue({ base: "2xl", md: "5xl" });
  const paragraphFontSize = useBreakpointValue({ base: "sm", md: "md" });

  return (
    <Box maxW="8xl" mx="auto" p={{ base: '0', lg: '12' }} minH="6xl">
      <Flex
        borderRadius={{ base: '0', md: '10px' }}
        direction="row"
        align="center"
        justify="space-between"
        backgroundImage={`
                    linear-gradient(
                        90deg,
                        rgba(20, 20, 20, 0.55) 0%,
                        rgba(20, 20, 20, 0.20) 55%,
                        rgba(20, 20, 20, 0.05) 100%
                    ),
                    url('/images/palyazatlogo.png')
                `}
       
        backgroundSize='cover'
        backgroundPosition={bgPosition}
        px={{ base: 4, md: 16 }}
        py={{ base: 6, md: 0 }}
        height="auto"
        position="relative"
        overflow="hidden"
      >

        <Box flex="1" pr={{ base: 4, md: 12 }} zIndex={1} textAlign="left">
          <Text
            fontFamily="'Playfair Display', serif"
            fontSize={headingFontSize}
            ps={{ base: 4, md: 5 }}
            lineHeight="1.2"
            fontWeight="bold"
            color="white"
            maxW="100%"
          >
            Pályázat
          </Text>
        </Box>
        <Box
          flexShrink={2}
          width={{ base: "150px", md: "390px" }}
          height={{ base: "100px", md: "340px" }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            svg: {
              height: blobSvgHeight,
              width: "auto",
              display: "block",
            }
          }}
        />
        <Box
          position="absolute"
          zIndex={0}
          top={{ base: '0', md: '-30px' }}
          left="0"
          width={{ base: "150px", md: "350px" }}
          height={{ base: "150px", md: "350px" }}
        >
          <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid slice"
          >
            <path
              transform="translate(100 100)"
              fill="rgba(230, 62, 62, 0.7)"
              d="M35,-57C48.4,-53,64.3,-49.7,74.9,-40.3C85.4,-30.9,90.6,-15.4,90.7,0.1C90.8,15.6,85.8,31.1,75.3,40.4C64.7,49.7,48.4,52.8,35,60.9C21.5,69,10.7,82.1,-1.7,85.1C-14.2,88.1,-28.3,80.9,-39.5,71.4C-50.6,61.9,-58.7,50.2,-66.7,38C-74.8,25.7,-82.9,12.8,-85.5,-1.5C-88.1,-15.9,-85.3,-31.7,-76.7,-43.2C-68.2,-54.6,-53.9,-61.7,-40.2,-65.5C-26.5,-69.3,-13.2,-70,-1.2,-67.9C10.8,-65.8,21.7,-61,35,-57Z"
            />
          </svg>
        </Box>
      </Flex>

      <Breadcrumb
        ms={2}
        mt={3}
        fontSize={{ base: 'xs', md: 'sm' }}
        spacing={{ base: '3px', md: '8px' }}
        separator={<ChevronRightIcon color='gray.400' />}
      >
        <BreadcrumbItem>
          <ReactLink to='/'>Főoldal</ReactLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <ReactLink to='/palyazat'>Pályázat</ReactLink>
        </BreadcrumbItem>
      </Breadcrumb>

    <Palyazatok/>
    </Box>
  );
};

export default PalyazatScreen;



